/* CHA Wire Antenna Workshop v1.0.0 */
document.addEventListener('DOMContentLoaded', function () {
  var data = window.CHA_WIRE_WORKSHOP_DATA;
  var center = document.querySelector('[data-wire-workshop]');
  if (!data || !center) return;

  var esc = function (value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character];
    });
  };
  var byId = function (id) { return data.transformers.find(function (item) { return item.id === id; }); };
  var product = function (id) { return data.products[id]; };
  var statusLabel = function (id) { return data.policy.statuses[id] || id; };
  var designGrid = center.querySelector('[data-wire-designs]');
  var resultCount = center.querySelector('[data-wire-count]');
  var search = center.querySelector('[data-wire-search]');
  var transformerFilter = center.querySelector('[data-wire-transformer]');
  var familyFilter = center.querySelector('[data-wire-family]');
  var bandFilter = center.querySelector('[data-wire-band]');
  var statusFilter = center.querySelector('[data-wire-status]');

  var openCenter = function () {
    center.hidden = false;
    requestAnimationFrame(function () { center.scrollIntoView({behavior:'smooth', block:'start'}); });
  };
  var closeCenter = function () {
    center.hidden = true;
    var launcher = document.querySelector('[data-wire-workshop-launcher]');
    if (launcher) launcher.scrollIntoView({behavior:'smooth', block:'center'});
  };

  var renderTransformers = function () {
    var target = center.querySelector('[data-wire-transformer-matrix]');
    target.innerHTML = data.transformers.map(function (item) {
      var directCount = data.designs.filter(function (design) { return design.transformers.indexOf(item.id) !== -1; }).length;
      return '<button type="button" class="cha-wire-transformer" data-wire-transformer-pick="' + esc(item.id) + '">' +
        '<span>' + esc(item.label) + '</span><strong>' + esc(item.type) + '</strong><small>' + esc(item.ohms) + '</small>' +
        '<p>' + esc(item.role) + '</p><b>' + directCount + ' Workshop/reference paths →</b></button>';
    }).join('');
  };

  var sourceList = function (sources) {
    return '<ul>' + sources.map(function (source) { return '<li>' + esc(source) + '</li>'; }).join('') + '</ul>';
  };

  var designCard = function (design) {
    var transformerNames = design.transformers.map(function (id) {
      var item = byId(id);
      return item ? item.label + ' ' + item.type : id;
    }).join(' · ');
    var parts = design.parts.map(function (id) {
      var item = product(id);
      return item ? '<a href="' + esc(item.url) + '">' + esc(item.name) + '</a>' : '';
    }).filter(Boolean).join('');
    var steps = design.build.map(function (step) { return '<li>' + esc(step) + '</li>'; }).join('');
    return '<details class="cha-wire-design" data-wire-design data-family="' + esc(design.family) + '" data-status="' + esc(design.status) + '">' +
      '<summary><div class="cha-wire-design__id"><span>' + esc(design.id) + '</span><b class="is-' + esc(design.status) + '">' + esc(statusLabel(design.status)) + '</b></div>' +
      '<h3>' + esc(design.title) + '</h3><p>' + esc(design.summary) + '</p>' +
      '<div class="cha-wire-design__tags"><span>' + esc(transformerNames) + '</span><span>' + esc(design.difficulty) + '</span><span>' + esc(design.bands.join(' / ')) + ' m</span></div><i>Open build record</i></summary>' +
      '<div class="cha-wire-design__body"><div class="cha-wire-design__specs">' +
      '<article><span>Starting dimensions</span><p>' + esc(design.dimensions) + '</p></article>' +
      '<article><span>Feed and transformer</span><p>' + esc(design.feed) + '</p></article>' +
      '<article><span>Return-current path</span><p>' + esc(design.returnPath) + '</p></article>' +
      '<article><span>Tuning and validation</span><p>' + esc(design.tuner) + '</p></article></div>' +
      '<div class="cha-wire-design__procedure"><div><h4>Controlled build sequence</h4><ol>' + steps + '</ol></div>' +
      '<aside><h4>Chameleon parts path</h4><div class="cha-wire-design__parts">' + parts + '</div><p>The lowest frequency-, mode-, duty-cycle-, voltage- or component-specific rating controls the completed system.</p></aside></div>' +
      '<div class="cha-wire-design__sources"><strong>Proven design references</strong>' + sourceList(design.sources) + '</div></div></details>';
  };

  var filterDesigns = function () {
    var query = (search.value || '').trim().toLowerCase();
    var transformer = transformerFilter.value;
    var family = familyFilter.value;
    var band = bandFilter.value;
    var status = statusFilter.value;
    var visible = data.designs.filter(function (design) {
      var haystack = [design.id, design.title, design.summary, design.family, design.dimensions, design.feed, design.sources.join(' ')].join(' ').toLowerCase();
      return (!query || haystack.indexOf(query) !== -1) &&
        (!transformer || design.transformers.indexOf(transformer) !== -1) &&
        (!family || design.family === family) &&
        (!band || design.bands.indexOf(band) !== -1) &&
        (!status || design.status === status);
    });
    designGrid.innerHTML = visible.map(designCard).join('') || '<p class="cha-wire-empty">No design matches every selected filter. Remove one filter or open the advanced reference catalog.</p>';
    resultCount.textContent = 'Showing ' + visible.length + ' of ' + data.designs.length + ' detailed design records.';
  };

  var renderFilters = function () {
    transformerFilter.innerHTML = '<option value="">All transformer paths</option>' + data.transformers.map(function (item) {
      return '<option value="' + esc(item.id) + '">' + esc(item.label + ' ' + item.type) + '</option>';
    }).join('');
    var families = Array.from(new Set(data.designs.map(function (item) { return item.family; }))).sort();
    familyFilter.innerHTML = '<option value="">All antenna families</option>' + families.map(function (item) {
      return '<option value="' + esc(item) + '">' + esc(item.charAt(0).toUpperCase() + item.slice(1)) + '</option>';
    }).join('');
  };

  var renderReferenceCatalog = function () {
    center.querySelector('[data-wire-reference-catalog]').innerHTML = data.referenceCatalog.map(function (group) {
      return '<article><span>' + esc(group.family) + '</span><ul>' + group.designs.map(function (item) { return '<li>' + esc(item) + '</li>'; }).join('') + '</ul><small>' + esc(group.source) + '</small></article>';
    }).join('');
  };

  var renderSources = function () {
    center.querySelector('[data-wire-sources]').innerHTML = data.sources.map(function (source) {
      var label = source.url ? '<a href="' + esc(source.url) + '" target="_blank" rel="noopener">' + esc(source.label) + ' ↗</a>' : '<strong>' + esc(source.label) + '</strong>';
      return '<li>' + label + (source.note ? '<span>' + esc(source.note) + '</span>' : '') + '</li>';
    }).join('');
  };

  var calculate = function (event) {
    if (event) event.preventDefault();
    var form = center.querySelector('[data-wire-calculator]');
    var frequency = Number(form.elements.frequency.value);
    var result = center.querySelector('[data-wire-calculator-result]');
    if (!(frequency > 0)) {
      result.innerHTML = '<p>Enter the exact intended operating frequency.</p>';
      return;
    }
    var nominal = 468 / frequency;
    var longStart = 490 / frequency;
    var quarter = 234 / frequency;
    var loop = 1005 / frequency;
    var meters = function (feet) { return feet * 0.3048; };
    result.innerHTML = '<article><span>Nominal half-wave total</span><strong>' + nominal.toFixed(2) + ' ft</strong><small>' + meters(nominal).toFixed(2) + ' m</small></article>' +
      '<article><span>Each equal dipole leg</span><strong>' + quarter.toFixed(2) + ' ft</strong><small>' + meters(quarter).toFixed(2) + ' m</small></article>' +
      '<article><span>Conservative insulated-wire start</span><strong>' + longStart.toFixed(2) + ' ft</strong><small>' + meters(longStart).toFixed(2) + ' m · trim in place</small></article>' +
      '<article><span>Nominal full-wave loop perimeter</span><strong>' + loop.toFixed(2) + ' ft</strong><small>' + meters(loop).toFixed(2) + ' m</small></article>';
  };

  var renderBandTable = function () {
    center.querySelector('[data-wire-band-table]').innerHTML = data.bandPresets.map(function (row) {
      return '<tr><th>' + esc(row.band) + '</th><td>' + row.frequency.toFixed(2) + '</td><td>' + row.dipole.toFixed(1) + '</td><td>' + row.leg.toFixed(1) + '</td><td>' + (row.dipole * 0.3048).toFixed(2) + '</td></tr>';
    }).join('');
  };

  renderTransformers();
  renderFilters();
  renderReferenceCatalog();
  renderSources();
  renderBandTable();
  filterDesigns();
  calculate();

  [search, transformerFilter, familyFilter, bandFilter, statusFilter].forEach(function (control) {
    control.addEventListener(control.tagName === 'INPUT' ? 'input' : 'change', filterDesigns);
  });
  center.querySelector('[data-wire-reset]').addEventListener('click', function () {
    search.value = ''; transformerFilter.value = ''; familyFilter.value = ''; bandFilter.value = ''; statusFilter.value = ''; filterDesigns();
  });
  center.querySelector('[data-wire-calculator]').addEventListener('submit', calculate);
  center.querySelector('[data-wire-calculator]').addEventListener('input', calculate);
  center.querySelector('[data-wire-transformer-matrix]').addEventListener('click', function (event) {
    var button = event.target.closest('[data-wire-transformer-pick]');
    if (!button) return;
    transformerFilter.value = button.getAttribute('data-wire-transformer-pick');
    filterDesigns();
    center.querySelector('[data-wire-library]').scrollIntoView({behavior:'smooth', block:'start'});
  });
  document.querySelectorAll('[data-wire-workshop-open]').forEach(function (button) {
    button.addEventListener('click', function (event) { event.preventDefault(); openCenter(); });
  });
  center.querySelectorAll('[data-wire-workshop-close]').forEach(function (button) { button.addEventListener('click', closeCenter); });

  var params = new URLSearchParams(location.search);
  if (params.get('tool') === 'wire-workshop' || location.hash === '#ckb-wire-workshop') {
    openCenter();
    var requestedTransformer = params.get('transformer');
    if (requestedTransformer && byId(requestedTransformer)) { transformerFilter.value = requestedTransformer; filterDesigns(); }
  }
});
